export default "__VITE_ASSET__BmVZseUS__"